import {getPageData} from "modules/page-events";
import {initS2SIPSec} from 'modules/helpers/s2s_ip_sec_helper';

function deleteRowClickHandler() {
  const list = $(this).parents('[data-num]'), num = list.data('num');
  if (list.find('.row').length > 1) {
    $(this).closest('.row').remove();
    list.data('num', num - 1);
  } else {
    list.find('.row input').val('');
  }
}

/**
 * @param {string} runbookSection summary|create
 * It's needed to split runbook data between 2 runbook sections on the runbook page.
 * summary - viewing/editing existing runbook.
 * create - creating new runbook.
 */
const initHotsiteRunbookAdvancedSettings = runbookSection => {
  const pageData = getPageData('hotsite_runbook_advanced_settings_page_data_' + runbookSection);
  const runbookSectionSelector = `#runbook_${runbookSection}_section`;
  const $runbookSection = $(runbookSectionSelector);

  const vpnSettings = $('#vo_vpn_settings_' + pageData.id),
      pfSettings = $('#vo_pf_settings_' + pageData.id),
      dhcpSettings = $('#vo_dhcp_settings_' + pageData.id),
      s2sVpnSettings = $('#vo_s2s_vpn_settings_' + pageData.id),
      s2sIpSecSettings = $('#vo_s2s_ipsec_settings_' + pageData.id);

  const createRecord = function (settingName, recordName, settingsPane, templateSelector, dataNum, data) {
    const template = settingsPane.find(templateSelector),
        record = template.clone(),
        num = dataNum !== undefined ? dataNum : settingsPane.data('num');

    record.find(':input').each(function () {
      const name = $(this).attr('name').replace(/(\[\d+\])$/, '');
      $(this).val((data || {})[name] || '').attr('name', name + '[' + num + ']')
          .attr('data-name', 'advanced_settings[' + settingName + '][' + recordName + '][add][' + num + '][' + name + ']');
    });
    record.removeClass('js-template').addClass('new').data('i', num);

    settingsPane.data('num', num + 1);
    return record;
  };

  const addListRecord = function (container, clonable, key, recordName, num) {
    const record = clonable.clone();

    if (num > 0) {
      record.find('label').text('');
    }

    record.find('input').each(function () {
      const $this = $(this),
          name = $this.attr('name').replace(/\[.+/, '');

      $this.val('');

      for (let i = 0; i < num + 2; i++) {
        if (!$('[name="' + name + '[' + i + ']"]').length) {
          $this.attr('name', name + '[' + i + ']');
          $this.attr('data-name', 'advanced_settings[' + key + '][' + recordName + '][' + i + '][' + name + ']');
          break;
        }
      }
    });
    container.append(record);
  };

  const createVPNUserRecord = function () {
    const settingName = 'vpn',
        recordName = 'users',
        templateSelector = '.js-vpn.js-template';
    return createRecord(settingName, recordName, vpnSettings, templateSelector);
  };

  const createPFRecord = function (interfaceNum) {
    const settingName = 'port_forward',
        templateSelector = '.js-pf.js-template:first',
        $table = pfSettings.find('.hotsite_port_fwd_rules[data-ip_num="' + interfaceNum + '"]'),
        ruleNumber = $table.data('num'),
        recordName = 'pf_interfaces][' + interfaceNum + '';
    $table.data('num', ruleNumber + 1);
    return createRecord(settingName, recordName, pfSettings, templateSelector, ruleNumber);
  };

  const addVPNUserRecord = function () {
    createVPNUserRecord().insertBefore(vpnSettings.find('.js-template')).show();
  };

  const addPFRecord = function (intNum) {
    const interfaceNum = intNum,
        pfTable = pfSettings.find('.hotsite_port_fwd_rules[data-ip_num="' + interfaceNum + '"]'),
        record = createPFRecord(interfaceNum);
    record.insertBefore(pfTable.find('.trow.js-template')).show();
  };

  const toggleNewVPNUserRecord = function () {
    if (vpnSettings.find('.js-vpn:not(.js-template)').length === 0) {
      addVPNUserRecord();
    }
  };

  const toggleNewPFRecord = function (interfaceNum) {
    if (pfSettings.find('.hotsite_port_fwd_rules[data-ip_num="' + interfaceNum + '"] .js-pf:not(.js-template)').length === 0) {
      addPFRecord(interfaceNum);
    }
  };

  const deleteRecord = function (record, dataIdKey) {
    if (record.data(dataIdKey) !== undefined) {
      record.addClass('deleted');
      record.find('input').attr('readonly', 'readonly');
    } else {
      record.remove();
    }
  };

  const deleteVPNUserRecord = function () {
    deleteRecord($(this).parents('.js-vpn'), 'user');
    toggleNewVPNUserRecord();
  };

  const deletePFRecord = function () {
    const $table = $(this).closest('.axtable'),
        interfaceNum = $table.data('ip_num');
    deleteRecord($(this).parents('.js-pf'), 'pf_rule');
    toggleNewPFRecord(interfaceNum);
  };

  const undoDeleteRecord = record => {
    record.removeClass('deleted').find('input').prop('readonly', false);
  };

  const restoreVPNUserRecord = function () {
    undoDeleteRecord($(this).parents('.js-vpn'));
  };

  const restorePFRecord = function () {
    undoDeleteRecord($(this).parents('.js-pf'));
  };

  const checkConnectionTypeText = () => {
    const type = $('[data-secure]').attr('data-secure'),
        $typeSecure = $('.type-secure');
    if (type === 'plain') {
      $typeSecure.addClass('invisible');
    } else {
      $typeSecure.removeClass('invisible');
    }
  };
  const checkUserAuthentication = function () {
    const authType = $('.auth_method_type').attr('data-method');
    if (authType === 'AD') {
      $('.auth-ad').removeClass('invisible');
      $('.auth-direct').addClass('invisible');
      checkConnectionTypeText();
    } else {
      $('.auth-direct').removeClass('invisible');
      $('.auth-ad').addClass('invisible');
    }
  };


  vpnSettings.find('.js-add-vpn a').click(addVPNUserRecord);

  vpnSettings.on('click', '.js-vpn .fa-trash-o', deleteVPNUserRecord);

  vpnSettings.on('click', '.js-vpn .fa-undo', restoreVPNUserRecord);

  pfSettings.find('.js-add-pf a').click(function () {
    addPFRecord($(this).data('ip-num'));
  });

  pfSettings.on('click', '.js-pf .fa-trash-o', deletePFRecord);

  pfSettings.on('click', '.js-pf .fa-undo', restorePFRecord);

  dhcpSettings.find('.adddns a').click(function () {
    const list = dhcpSettings.find('.dns_list'), num = list.data('num');
    addListRecord(list, list.find('.row:last'), 'dhcp', 'dns_servers', num);
    list.data('num', num + 1);
  });

  dhcpSettings.find('.addmac2ip a').click(function () {
    const list = dhcpSettings.find('.mac2ip_list'), num = list.data('num');
    addListRecord(list, list.find('.row:last'), 'dhcp', 'mac_to_ip', num);
    list.data('num', num + 1);
  });

  dhcpSettings.find('.dns_list, .mac2ip_list').on('click', '.js-delete-row', function () {
    deleteRowClickHandler.call(this);
  });

  s2sVpnSettings.on('click', '[data-config] [type=radio]', function () {
    $(this).parents('[data-config]').attr('data-config', this.value);
  });

  s2sVpnSettings.find('.addip a').click(function () {
    const list = s2sVpnSettings.find('.allowed_ips_list'), num = list.data('num');
    addListRecord(list, list.find('.row:last'), 's2s_vpn', 'allowed_ips', num);
    list.data('num', num + 1);
  });

  s2sVpnSettings.find('.allowed_ips_list').on('click', '.js-delete-row', function () {
    deleteRowClickHandler.call(this);
  });

  const checkboxOnChange = function () {
    const $this = $(this),
        isChecked = $this.is(':checked'),
        form = $this.parents('form');

    if (isChecked) {
      form.removeClass('state-off');
    } else {
      form.addClass('state-off');
    }
  };

  vpnSettings.on('change', '.vpn_enabled', checkboxOnChange);
  pfSettings.on('change', '.pf_enabled', checkboxOnChange);
  dhcpSettings.on('change', '.dhcp_enabled', checkboxOnChange);
  s2sVpnSettings.on('change', '.s2s_vpn_enabled', checkboxOnChange);
  s2sIpSecSettings.on('change', '.s2s_ipsec_enabled', checkboxOnChange);

  checkUserAuthentication();

  $runbookSection.find('.toggle_checkbox').change(function () {
    emulateCheck(this.id);
  }).trigger('change');

  $(vpnSettings).on('data-restored', function () {
    toggleNewVPNUserRecord();
  });

  $(pfSettings).on('data-restored', function () {
    pfSettings.find('.hotsite_port_fwd_rules').each(function () {
      const $rulesTable = $(this);
      if ($rulesTable.find('.js-pf:not(.js-template)').length === 0) {
        addPFRecord($rulesTable.data('ip_num'));
      }
    });
  });

  $runbookSection.find('[name=auth_method]').click(function () {
    $runbookSection.find('[data-method]').attr('data-method', this.value);
    checkUserAuthentication();
  });

  $runbookSection.find('[name=connection_type]').click(function () {
    $runbookSection.find('[data-secure]').attr('data-secure', this.value);
    checkConnectionTypeText();
  });

  initS2SIPSec($(`#s2s_ipsec_edit_form_${pageData.id}`), {
    remoteSites: pageData.remote_sites,
    maxSubnetsTip: pageData.max_10_subnets_tip,
    subnetsLimit: 10,
    stayLocalIpDisabledIfSelected: pageData.stay_local_ip_disabled_if_selected
  }, {
    subnetsName: 'remote_subnets'
  });
}

export {initHotsiteRunbookAdvancedSettings}
